import * as React from "react";
import { SVGProps, memo } from "react";
const SvgDataCatalogLineageUsersActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="data-catalog-lineage-users-active_svg__Layer_1"
    x={0}
    y={0}
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <style>{".data-catalog-lineage-users-active_svg__st0{fill:#333}"}</style>
    <path
      className="data-catalog-lineage-users-active_svg__st0"
      d="M8.5 5C7.1 5 6 6.3 6 8s1.1 3 2.5 3S11 9.7 11 8c0-1.6-1.1-3-2.5-3zm0 5C7.7 10 7 9.1 7 8s.7-2 1.5-2 1.5.9 1.5 2-.7 2-1.5 2zM16 4c-1.1 0-2 1.1-2 2.5S14.9 9 16 9s2-1.1 2-2.5S17.1 4 16 4zm0 4c-.6 0-1-.7-1-1.5S15.5 5 16 5c.6 0 1 .7 1 1.5S16.5 8 16 8zM9.6 13H7.5C5.2 13 3 15 3 17.2v1.9c0 .5.4.9.9.9h9.2c.5 0 .9-.4.9-.9v-1.9c0-2.1-2.1-4.2-4.4-4.2zm3.4 6H4v-1.8C4 15.6 5.7 14 7.5 14h2.1c.8 0 1.7.4 2.4 1s1 1.4 1 2.2V19zM16.8 11h-1.5c-1.1 0-2.1.7-2.7 1.7l.8.7c.4-.8 1.2-1.4 1.9-1.4h1.6c1.1 0 2.2 1.3 2.2 2.6V16h-4v1h4.3c.4 0 .7-.3.7-.7v-1.7c-.1-1.8-1.7-3.6-3.3-3.6z"
    />
  </svg>
);
const Memo = memo(SvgDataCatalogLineageUsersActive);
export default Memo;
